import { DictionariesService, DictionaryItem } from "@sa/rep-mdm";
import { orderBy } from "lodash";
import { SLIDE_NUMBER } from "../constants";

export async function getDefaultCalendarSelection(commodities: number, attributes: number[], dictionariesService: DictionariesService) {
  const lastYearCalendar = await dictionariesService.getDictionary({
    id: 'slides-f-last-calendar',
    parameters: {
      attributes: attributes.map(String).join(','),
      units: '',
      commodities: String(commodities),
      countries: '',
      slide: SLIDE_NUMBER,
    },
  });
  const calendarItems = await lastYearCalendar.getAll();
  const defaultLastYear = Number(`1${new Date().getFullYear()}0101`);
  const lastYear = calendarItems.length ? Number(calendarItems[0].id) : defaultLastYear;

  return lastYear;
}